module.exports = {
	"contractName": "MorganStark",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "balance",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "constructor"
		},
		{
			"constant": false,
			"inputs": [],
			"name": "collegeFund",
			"outputs": [],
			"payable": true,
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "checkBalance",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		}
	],
	"bytecode": "0x6080604052341561000f57600080fd5b60008054600160a060020a0319163317905560f98061002f6000396000f30060806040526004361060525763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663b69ef8a881146057578063c71daccb14607b578063d1e4e9a314608d575b600080fd5b348015606257600080fd5b5060696095565b60408051918252519081900360200190f35b348015608657600080fd5b506069609b565b609360a0565b005b60015481565b303190565b60005473ffffffffffffffffffffffffffffffffffffffff16331460c357600080fd5b60018054340190555600a165627a7a723058201104c2feaedb262837552c299d1d1421fc03167cacc107101729dbed273ca76d0029",
	"deployedBytecode": "0x60806040526004361060525763ffffffff7c0100000000000000000000000000000000000000000000000000000000600035041663b69ef8a881146057578063c71daccb14607b578063d1e4e9a314608d575b600080fd5b348015606257600080fd5b5060696095565b60408051918252519081900360200190f35b348015608657600080fd5b506069609b565b609360a0565b005b60015481565b303190565b60005473ffffffffffffffffffffffffffffffffffffffff16331460c357600080fd5b60018054340190555600a165627a7a723058201104c2feaedb262837552c299d1d1421fc03167cacc107101729dbed273ca76d0029",
	"sourceMap": "26:362:18:-;;;138:9;:14;130:23;;;;;;159:5;:18;;-1:-1:-1;;;;;;159:18:18;167:10;159:18;;;26:362;;;;;;",
	"deployedSourceMap": "26:362:18:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;68:22;;8:9:-1;5:2;;;30:1;27;20:12;5:2;68:22:18;;;;;;;;;;;;;;;;;;;;293:93;;8:9:-1;5:2;;;30:1;27;20:12;5:2;293:93:18;;;;186:103;;;;;;68:22;;;;:::o;293:93::-;368:4;360:21;293:93;:::o;186:103::-;252:5;;;;238:10;:19;230:28;;;;;;264:7;:20;;275:9;264:20;;;186:103::o",
	"source": "pragma solidity ^0.4.24;\n\ncontract MorganStark {\n  address owner;\n  uint256 public balance;\n\n  constructor() public payable {\n    require(msg.value == 0);\n    owner = msg.sender;\n  }\n\n  function collegeFund() public payable {\n    require(msg.sender == owner);\n    balance += msg.value;\n  }\n\n  function checkBalance() public view returns (uint256) {\n    return address(this).balance;\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/MorganStark.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/MorganStark.sol",
		"exportedSymbols": {
			"MorganStark": [
				1914
			]
		},
		"id": 1915,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1866,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:18"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1914,
				"linearizedBaseContracts": [
					1914
				],
				"name": "MorganStark",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1868,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 1914,
						"src": "51:13:18",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 1867,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "51:7:18",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 1870,
						"name": "balance",
						"nodeType": "VariableDeclaration",
						"scope": 1914,
						"src": "68:22:18",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1869,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "68:7:18",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1885,
							"nodeType": "Block",
							"src": "124:58:18",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1877,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1874,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "138:3:18",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1875,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "138:9:18",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1876,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "151:1:18",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "138:14:18",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1873,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "130:7:18",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1878,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "130:23:18",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1879,
									"nodeType": "ExpressionStatement",
									"src": "130:23:18"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1883,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1880,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1868,
											"src": "159:5:18",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1881,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "167:3:18",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 1882,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "167:10:18",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "159:18:18",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1884,
									"nodeType": "ExpressionStatement",
									"src": "159:18:18"
								}
							]
						},
						"documentation": null,
						"id": 1886,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1871,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "106:2:18"
						},
						"payable": true,
						"returnParameters": {
							"id": 1872,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "124:0:18"
						},
						"scope": 1914,
						"src": "95:87:18",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1901,
							"nodeType": "Block",
							"src": "224:65:18",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 1893,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1890,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "238:3:18",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1891,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "238:10:18",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 1892,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1868,
													"src": "252:5:18",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "238:19:18",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1889,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "230:7:18",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1894,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "230:28:18",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1895,
									"nodeType": "ExpressionStatement",
									"src": "230:28:18"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1899,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1896,
											"name": "balance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1870,
											"src": "264:7:18",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "+=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1897,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "275:3:18",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 1898,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "value",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "275:9:18",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "264:20:18",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1900,
									"nodeType": "ExpressionStatement",
									"src": "264:20:18"
								}
							]
						},
						"documentation": null,
						"id": 1902,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "collegeFund",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1887,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "206:2:18"
						},
						"payable": true,
						"returnParameters": {
							"id": 1888,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "224:0:18"
						},
						"scope": 1914,
						"src": "186:103:18",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1912,
							"nodeType": "Block",
							"src": "347:39:18",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1908,
													"name": "this",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2992,
													"src": "368:4:18",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_MorganStark_$1914",
														"typeString": "contract MorganStark"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_contract$_MorganStark_$1914",
														"typeString": "contract MorganStark"
													}
												],
												"id": 1907,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "360:7:18",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 1909,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "360:13:18",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 1910,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "balance",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "360:21:18",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 1906,
									"id": 1911,
									"nodeType": "Return",
									"src": "353:28:18"
								}
							]
						},
						"documentation": null,
						"id": 1913,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "checkBalance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1903,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "314:2:18"
						},
						"payable": false,
						"returnParameters": {
							"id": 1906,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1905,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1913,
									"src": "338:7:18",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1904,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "338:7:18",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "337:9:18"
						},
						"scope": 1914,
						"src": "293:93:18",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1915,
				"src": "26:362:18"
			}
		],
		"src": "0:389:18"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/MorganStark.sol",
		"exportedSymbols": {
			"MorganStark": [
				1914
			]
		},
		"id": 1915,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 1866,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".24"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:18"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 1914,
				"linearizedBaseContracts": [
					1914
				],
				"name": "MorganStark",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 1868,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 1914,
						"src": "51:13:18",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 1867,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "51:7:18",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "internal"
					},
					{
						"constant": false,
						"id": 1870,
						"name": "balance",
						"nodeType": "VariableDeclaration",
						"scope": 1914,
						"src": "68:22:18",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 1869,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "68:7:18",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1885,
							"nodeType": "Block",
							"src": "124:58:18",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_uint256",
													"typeString": "uint256"
												},
												"id": 1877,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1874,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "138:3:18",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1875,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "value",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "138:9:18",
													"typeDescriptions": {
														"typeIdentifier": "t_uint256",
														"typeString": "uint256"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"hexValue": "30",
													"id": 1876,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "151:1:18",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0"
												},
												"src": "138:14:18",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1873,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "130:7:18",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1878,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "130:23:18",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1879,
									"nodeType": "ExpressionStatement",
									"src": "130:23:18"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1883,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1880,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1868,
											"src": "159:5:18",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1881,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "167:3:18",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 1882,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "sender",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "167:10:18",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "159:18:18",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 1884,
									"nodeType": "ExpressionStatement",
									"src": "159:18:18"
								}
							]
						},
						"documentation": null,
						"id": 1886,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1871,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "106:2:18"
						},
						"payable": true,
						"returnParameters": {
							"id": 1872,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "124:0:18"
						},
						"scope": 1914,
						"src": "95:87:18",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1901,
							"nodeType": "Block",
							"src": "224:65:18",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 1893,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 1890,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "238:3:18",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 1891,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "238:10:18",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"id": 1892,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 1868,
													"src": "252:5:18",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "238:19:18",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 1889,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "230:7:18",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 1894,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "230:28:18",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 1895,
									"nodeType": "ExpressionStatement",
									"src": "230:28:18"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 1899,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 1896,
											"name": "balance",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 1870,
											"src": "264:7:18",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "Assignment",
										"operator": "+=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 1897,
												"name": "msg",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2937,
												"src": "275:3:18",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_message",
													"typeString": "msg"
												}
											},
											"id": 1898,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "value",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "275:9:18",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"src": "264:20:18",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"id": 1900,
									"nodeType": "ExpressionStatement",
									"src": "264:20:18"
								}
							]
						},
						"documentation": null,
						"id": 1902,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "collegeFund",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1887,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "206:2:18"
						},
						"payable": true,
						"returnParameters": {
							"id": 1888,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "224:0:18"
						},
						"scope": 1914,
						"src": "186:103:18",
						"stateMutability": "payable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 1912,
							"nodeType": "Block",
							"src": "347:39:18",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"expression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 1908,
													"name": "this",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2992,
													"src": "368:4:18",
													"typeDescriptions": {
														"typeIdentifier": "t_contract$_MorganStark_$1914",
														"typeString": "contract MorganStark"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_contract$_MorganStark_$1914",
														"typeString": "contract MorganStark"
													}
												],
												"id": 1907,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"lValueRequested": false,
												"nodeType": "ElementaryTypeNameExpression",
												"src": "360:7:18",
												"typeDescriptions": {
													"typeIdentifier": "t_type$_t_address_$",
													"typeString": "type(address)"
												},
												"typeName": "address"
											},
											"id": 1909,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "typeConversion",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "360:13:18",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"id": 1910,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"memberName": "balance",
										"nodeType": "MemberAccess",
										"referencedDeclaration": null,
										"src": "360:21:18",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"functionReturnParameters": 1906,
									"id": 1911,
									"nodeType": "Return",
									"src": "353:28:18"
								}
							]
						},
						"documentation": null,
						"id": 1913,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": true,
						"modifiers": [],
						"name": "checkBalance",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 1903,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "314:2:18"
						},
						"payable": false,
						"returnParameters": {
							"id": 1906,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 1905,
									"name": "",
									"nodeType": "VariableDeclaration",
									"scope": 1913,
									"src": "338:7:18",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_uint256",
										"typeString": "uint256"
									},
									"typeName": {
										"id": 1904,
										"name": "uint256",
										"nodeType": "ElementaryTypeName",
										"src": "338:7:18",
										"typeDescriptions": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "337:9:18"
						},
						"scope": 1914,
						"src": "293:93:18",
						"stateMutability": "view",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 1915,
				"src": "26:362:18"
			}
		],
		"src": "0:389:18"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.806Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/MorganStark.json
// module id = 1046
// module chunks = 0